/**
 * Formatters for the Personal CFO.
 * Everything monospace-friendly (JetBrains Mono) with tight negative handling.
 */

export function fmtMoney(value, { currency = "USD", signed = false, compact = false } = {}) {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  const abs = Math.abs(value);
  let out;
  if (compact && abs >= 10000) {
    if (abs >= 1_000_000) out = `$${(value / 1_000_000).toFixed(2)}M`;
    else if (abs >= 1_000) out = `$${(value / 1_000).toFixed(1)}K`;
    else out = `$${value.toFixed(0)}`;
  } else {
    out = value.toLocaleString("en-US", {
      style: "currency",
      currency,
      maximumFractionDigits: abs >= 1000 ? 0 : 2,
    });
  }
  if (signed && value > 0) out = `+${out}`;
  return out;
}

export function fmtPct(value, digits = 1) {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  return `${value >= 0 ? "" : ""}${value.toFixed(digits)}%`;
}

export function fmtNumber(value, digits = 0) {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  return value.toLocaleString("en-US", { maximumFractionDigits: digits });
}

export function gradeColor(grade) {
  if (!grade) return "#94A3B8";
  const g = grade[0];
  if (g === "A") return "#10B981";
  if (g === "B") return "#84CC16";
  if (g === "C") return "#FACC15";
  if (g === "D") return "#F97316";
  return "#EF4444";
}

export const CATEGORY_LABELS = {
  housing: "Vivienda",
  food: "Comida",
  transport: "Transporte",
  subscription: "Suscripciones",
  utilities: "Servicios",
  entertainment: "Entretenimiento",
  health: "Salud",
  education: "Educación",
  other: "Otro",
};

export const ACCOUNT_TYPE_LABELS = {
  checking: "Cuenta corriente",
  savings: "Ahorros",
  investment: "Inversión",
  retirement: "Retiro",
  cash: "Efectivo",
  crypto: "Cripto",
  credit_card: "Tarjeta de crédito",
  real_estate: "Bien raíz",
  other: "Otro",
};

export const DEBT_TYPE_LABELS = {
  credit_card: "Tarjeta de crédito",
  student: "Préstamo estudiantil",
  mortgage: "Hipoteca",
  auto: "Auto",
  personal: "Personal",
  business: "Negocio",
  medical: "Médica",
  family: "Familia",
  other: "Otra",
};

export const FREQUENCY_LABELS = {
  monthly: "Mensual",
  biweekly: "Quincenal",
  weekly: "Semanal",
  annually: "Anual",
  one_time: "Una vez",
};

export const INCOME_SOURCE_LABELS = {
  salary: "Salario",
  freelance: "Freelance",
  business_revenue: "Ingresos de negocio",
  rental: "Renta / Alquiler",
  dividend: "Dividendos",
  other: "Otro",
};
